import * as React from 'react';

function SvgPendingIcon(props) {
  return (
    <svg
      data-name="Pending Icon"
      id="pending_icon__1"
      width={props.size || 22.401}
      height={props.size || 22.401}
      viewBox="0 0 22.401 22.401"
      xmlSpace="preserve"
      {...props}
    >
      <path
        data-name="Path 451"
        d="M11.2 0a11.2 11.2 0 1011.2 11.2A11.214 11.214 0 0011.2 0zm4.739 12.493H11.2A1.293 1.293 0 019.908 11.2V6.462a1.292 1.292 0 112.585 0v3.446h3.446a1.292 1.292 0 010 2.585z"
        fill="#fff"
      />
    </svg>
  );
}

export default SvgPendingIcon;
